import IndicatorDataSource from "./IndicatorDataSource";
import {SimpleNumberFormat} from "../../../../global"
 
export default class Indicator {
  constructor(indicator = {}) {
    this.id = indicator.id ? indicator.id : 0;
    this.productionUnitId = indicator.productionUnitId ? indicator.productionUnitId : 0;
    this.system = indicator.system ? indicator.system : "P";
    this.indicatorName = indicator.indicatorName ? indicator.indicatorName : "";
    this.setPoint = indicator.setPoint ? SimpleNumberFormat(indicator.setPoint) : "";
    this.indicatorRule = indicator.indicatorRule ? indicator.indicatorRule : "= 4 5";
    this.operatingRange = this.getOperationalRange(),
    this.criticalRange = this.getCriticalRange(),
    this.reliabilityThreshold = indicator.reliabilityThreshold ? indicator.reliabilityThreshold : 60,
    this.reliabilityCritical = indicator.reliabilityCritical ? indicator.reliabilityCritical : 50,
    this.unitMensure = indicator.unitMensure ? indicator.unitMensure : "";
    this.calcType = indicator.calcType ? indicator.calcType : "online";
    this.calcDateTime = indicator.calcDateTime ? indicator.calcDateTime : "06:00";
    this.indRealList = indicator.indRealList ? typeof indicator.indRealList == "string" ?  JSON.parse(indicator.indRealList).map(i => new IndicatorDataSource(i)) : indicator.indRealList : []
    this.indPrevList = indicator.indPrevList ? typeof indicator.indPrevList == "string" ?  JSON.parse(indicator.indPrevList).map(i => new IndicatorDataSource(i)) : indicator.indPrevList : []
    this.valueOnline = indicator.valueOnline ? indicator.valueOnline : ""
    this.valueDay = indicator.valueDay ? indicator.valueDay : ""
    this.valueWeek = indicator.valueWeek ? indicator.valueWeek : ""
    this.valueMonth = indicator.valueMonth ? indicator.valueMonth : ""
    this.valueHarvest = indicator.valueHarvest ? indicator.valueHarvest : ""
    this.targetOnline = indicator.targetOnline ? indicator.targetOnline : ""
    this.targetDay = indicator.targetDay ? indicator.targetDay : ""
    this.targetWeek = indicator.targetWeek ? indicator.targetWeek : ""
    this.targetMonth = indicator.targetMonth ? indicator.targetMonth : ""
    this.targetHarvest = indicator.targetHarvest ? indicator.targetHarvest : ""
    this.isNew = indicator.isNew ? true : false
    this.positions = indicator.positions ? (typeof indicator.positions == "string" ? JSON.parse(indicator.positions) : indicator.positions) : new Array()
    this.createScreen = indicator.createScreen ? (typeof indicator.createScreen == "string" ? [JSON.parse(indicator.createScreen)] : indicator.createScreen) : new Array()
    this.triggers = indicator.triggers ? (typeof indicator.triggers == "string" ? JSON.parse(indicator.triggers) : indicator.triggers) : {}
    this.note = indicator.note ? (typeof indicator.note == "string" ? JSON.parse(indicator.note) : indicator.note) : {}
  }

  getStash(){
    return {
      ...this,
      indicatorRule: this.getIndicatorRule(),
      criticalRange: String(this.criticalRange),
      operatingRange: String(this.operatingRange),
      reliabilityCritical: String(this.reliabilityCritical),
      reliabilityThreshold: String(this.reliabilityThreshold),
      setPoint: String(this.setPoint),
      indRealList: JSON.stringify(this.indRealList.map(r => r.type != 0 ? r : {...r, key: r.key.split(":")[0], variables: r.variables.map(v => JSON.stringify(v))})),
      indPrevList: JSON.stringify(this.indPrevList),
      positions: JSON.stringify(this.positions),
      createScreen: JSON.stringify(this.createScreen[0]),
      triggers: JSON.stringify(this.triggers),
      opcNote: JSON.stringify(this.opcNote),
      note: JSON.stringify(this.note),
    }
  }

  Key(){
    return `${this.id}-${this.productionUnitId}-${this.system}`
  }

  getIndicatorRule(){
    let signal = this.indicatorRule.split(" ")[0].trim()
    return `${signal} ${this.operatingRange} ${this.criticalRange}`
  }

  getOperationalRange(){
    let operationalRange = this.indicatorRule.split(" ")[1].trim()
    let value = SimpleNumberFormat(operationalRange)
    return isNaN(value) ? 4 : value 
  }

  getCriticalRange(){
    let criticalRange = this.indicatorRule.split(" ")[2].trim()
    var value = SimpleNumberFormat(criticalRange)
    return isNaN(value) ? this.getOperationalRange() : value 
  }

  getIndcatorStep1(){
    let signal = this.indicatorRule.split(" ")
    this.operatingRange = SimpleNumberFormat(signal[1])
    this.criticalRange = SimpleNumberFormat(signal[2])

    let inferiorLimit =  (1 - this.operatingRange /100) * this.setPoint 
    let upperLimit = (1 + this.operatingRange/100) * this.setPoint 

    if(signal[0] == ">")
    {
      inferiorLimit = ""
    }
    if(signal[0] == "<")
    {
      upperLimit = ""
    }

    return {
      indicatorName : this.indicatorName,
      unitMensure : this.unitMensure,
      calcType : this.calcType,
      calcDateTime : this.calcDateTime,
      inferiorLimit: inferiorLimit,
      setPoint: this.setPoint,
      upperLimit: upperLimit,
      operatingRange: SimpleNumberFormat(this.operatingRange),
      criticalRange: SimpleNumberFormat(this.criticalRange),
      signal: signal[0]
    }
  }

  getIndicatorName(){
    return this.unitMensure ? `${this.indicatorName} (${this.unitMensure})` : this.indicatorName;
  }
}